import { createClient } from '@supabase/supabase-js';
// import { Database } from './types';
const configs = JSON.parse(process.env.SUPABASE_CONFIG);

const supabaseUrl = configs['SUPABASE_URL'];
const supabaseAnonKey = configs['SUPABASE_ANON_KEY'];

export const supabase = createClient(supabaseUrl, supabaseAnonKey);
